import React from 'react';
import PropTypes from 'prop-types';
import { Stars } from './stars';

export const StarRating = props => (
    <span className="rating-stars__stars">
        <Stars { ...props.stars } />
    </span>
);

StarRating.propTypes = {
    stars: PropTypes.shape( Stars.propTypes ).isRequired,
};
